export default [
  { value: null, text: 'Please select Font' },
  { value: 1, text: 'Arial' },
  { value: 2, text: 'Georgia' },
  { value: 3, text: 'Open Sans' },
  { value: 4, text: 'Roboto' },
  { value: 5, text: 'Times New Roman' },
  { value: 6, text: 'Verdana' },
]
